import { hot } from 'react-hot-loader/root';
import "normalize.css";
import { Editor } from './editor/Editor';
import styled, { createGlobalStyle } from 'styled-components';
import React, { useEffect } from "react";
import Modal from 'react-modal';
import { Route, Switch, useLocation } from 'react-router';
import { routes } from '../data/routes';
import { observer } from 'mobx-react-lite';
import { RestartingAfterLoggingOutNotification } from './auth/RestartingAfterLoggingOutNotification';
import { MainGameRoute } from './game/MainGameRoute';
import { userStore } from '../stores/UserStore';
import { WorkshopManagement } from './workshopmanagement/WorkshopManagement';
import { PlayCodeRoute } from './game/PlayCodeRoute';
import { NavigateTo } from './shared/NavigateTo';
import { PublicMenu } from './publicMenu/PublicMenu';
const GlobalStyle = createGlobalStyle(["html{font-size:16px;font-family:'Nunito',sans-serif;}h1,h2,h3,h4,h5{font-size:16px;}::backdrop{background-color:white;}html{box-sizing:border-box;}*,*:before,*:after{box-sizing:inherit;}html,body{overscroll-behavior-y:contain;user-select:none;}"]);
const Container = styled.div.withConfig({
  displayName: "App__Container",
  componentId: "sc-1v5aa84-0"
})(["margin:0.3em;"]);
const AppInner = observer(() => {
  const location = useLocation();
  if (userStore.restartingAfterLoggingOut) return /*#__PURE__*/React.createElement(RestartingAfterLoggingOutNotification, null);

  if (location.pathname === routes.home && userStore.mayUseWorkshopManagementView) {
    return /*#__PURE__*/React.createElement(NavigateTo, {
      to: routes.workshopManagement
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: routes.mainGame,
    component: MainGameRoute
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.publicGameVariant,
    component: MainGameRoute
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.playCode,
    component: PlayCodeRoute
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.workshopManagement,
    component: WorkshopManagement
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.publicMenu,
    component: PublicMenu
  }), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Editor, null))));
});

const App = () => {
  useEffect(() => {
    // componentDidMount event
    Modal.setAppElement("#appRootContainer");
  }, []);
  return /*#__PURE__*/React.createElement(Container, {
    id: "appRootContainer"
  }, /*#__PURE__*/React.createElement(AppInner, null));
};

export default App;